import { Skeleton } from "@/components/ui/skeleton";
import { useTranslation as useI18n } from "react-i18next";
import { useTranslation as useTextTranslation } from "@/hooks/useTranslation";

interface TranslatedTextProps {
  text: string | undefined;
  className?: string;
  showLoading?: boolean;
}

const toTargetLang = (lng: string): "es" | "en" | "pt-BR" => {
  if (lng.startsWith("pt")) return "pt-BR";
  if (lng.startsWith("en")) return "en";
  return "es";
};

export const TranslatedText = ({ text, className, showLoading = false }: TranslatedTextProps) => {
  const { i18n } = useI18n();
  const targetLang = toTargetLang(i18n.language);

  // For Portuguese users, show original text (API often returns Portuguese content)
  const needsTranslation = !i18n.language.startsWith('pt');

  // Ask backend to auto-detect the source language and translate to the UI language.
  const { translatedText, isTranslating } = useTextTranslation(
    needsTranslation ? text : undefined, 
    "auto", 
    targetLang
  );

  if (isTranslating && showLoading) {
    return <Skeleton className="h-4 w-full" />;
  }

  return <span className={className}>{needsTranslation ? (translatedText || text) : text}</span>;
};
